// extracted by mini-css-extract-plugin
export default {"list":"List_list__nhYQU","list_header":"List_list_header__G0WfT","list_body":"List_list_body__yJYIt"};